const applyCellBorderStyle = (
  type:
    | "bordernone"
    | "bordertop"
    | "borderbottom"
    | "borderhorizontal"
    | "borderall"
    | "borderdashed"
    | "borderstyle",
  borderStyle: "solid" | "dashed" | "dotted" = "solid",
  cell: any
) => {
  if (type === "bordernone") {
    cell.style["border-style"] = null;
    cell.style["border-top"] = null;
    cell.style["border-bottom"] = null;
    cell.style.border = "none";
  } else if (type === "bordertop") {
    cell.style.border = null;
    cell.style["border-bottom"] = null;
    cell.style["border-style"] = null;
    cell.style["border-top"] = `1px ${borderStyle} #ccc`;
  } else if (type === "borderbottom") {
    cell.style.border = null;
    cell.style["border-top"] = null;
    cell.style["border-style"] = null;
    cell.style["border-bottom"] = `1px ${borderStyle} #ccc`;
  } else if (type === "borderhorizontal") {
    cell.style.border = null;
    cell.style["border-top"] = null;
    cell.style["border-style"] = null;
    cell.style["border-top"] = `1px ${borderStyle} #ccc`;
    cell.style["border-bottom"] = `1px ${borderStyle} #ccc`;
  } else if (type === "borderall") {
    cell.style["border-style"] = null;
    cell.style["border-top"] = null;
    cell.style["border-bottom"] = null;
    cell.style.border = `1px ${borderStyle} #ccc`;
  } else {
    if (cell.style["border"]) {
      cell.style.border = `1px ${borderStyle} #ccc`;
    } else {
      if (cell.style["border-top"]) {
        cell.style["border-top"] = `1px ${borderStyle} #ccc`;
      }
      if (cell.style["border-bottom"]) {
        cell.style["border-bottom"] = `1px ${borderStyle} #ccc`;
      }
    }
  }
};

/**
 * @description - Handle table border styling
 * @param {"bordernone"| "bordertop"| "borderbottom"| "borderhorizontal"| "borderall"| "borderstyle"} type - Border styling type
 * @param {any} editor - Editor current instance
 * @param {"solid" | "dashed" | "dotted"} borderStyle - Style of the border
 */
export const handleTableCellsBorderStyling = (
  type:
    | "bordernone"
    | "bordertop"
    | "borderbottom"
    | "borderhorizontal"
    | "borderall"
    | "borderstyle",
  editor: any,
  borderStyle: "solid" | "dashed" | "dotted" = "solid"
) => {
  const editorDoc = editor.getDocument();
  const selectedCells = editorDoc.querySelectorAll("td[__rte_selected_cell]");
  if (selectedCells && selectedCells.length > 1) {
    for (const cell of selectedCells) {
      applyCellBorderStyle(type, borderStyle, cell);
    }
  } else {
    const selectedElement = editor.getSelectionElement();
    applyCellBorderStyle(type, borderStyle, selectedElement);
  }
};
